import { Controller } from "stimulus";

export default class extends Controller {
    static targets = ["trigger", "searchInput", "contentBox", "dropdownItem"];

    // connect() {
    //     console.log("✅ filter_controller.js connected");
    //     console.log("🔍 Available targets:", this.hasSearchInputTarget, this.hasTriggerTarget, this.hasAccountItemTarget);
    // }


    focusSearch() {
        requestAnimationFrame(() => {
            if (this.searchInputTarget.offsetParent !== null) {
                this.searchInputTarget.focus();
            }
        });
    }

    filterAccounts() {
        const filter = this.searchInputTarget.value.toLowerCase();
        let matchCount = 0;

        this.dropdownItemTargets.forEach(item => {
            const text = item.textContent.toLowerCase();
            const isMatch = text.includes(filter);
            item.style.display = isMatch ? '' : 'none';
            if (isMatch) matchCount++;
        });

        // Handle "No results found"
        const existingNoResults = this.contentBoxTarget.querySelector("#no-results");
        if (matchCount === 0) {
            if (!existingNoResults) {
                const noResults = document.createElement("div");
                noResults.id = "no-results";
                noResults.textContent = "No results found";
                Object.assign(noResults.style, {
                    padding: "0.75rem",
                    color: "#999",
                    textAlign: "center"
                });
                this.contentBoxTarget.appendChild(noResults);
            }
        } else if (existingNoResults) {
            existingNoResults.remove();
        }
    }
}
